import { jsx as _jsx } from "react/jsx-runtime";
import { Panel } from "@cinch-nx/landing-ui-shared";
import { Secondary } from "@cinch-nx/landing-ui-shared";
import Link from "next/link";
import styles from "./related-jargon.module.css";
export const RelatedJargon = ({ items  })=>{
    /*#__PURE__*/ return _jsx("div", {
        className: styles.related,
        "data-testid": "jargon-list",
        children: items.length > 0 && items.filter((item)=>item && item.content).map((item, index)=>{
            var ref, ref1;
            /*#__PURE__*/ return _jsx(Panel, {
                title: (ref = item.content) === null || ref === void 0 ? void 0 : ref.question,
                subtitle: (ref1 = item.content) === null || ref1 === void 0 ? void 0 : ref1.summary,
                isPadded: true,
                children: /*#__PURE__*/ _jsx("div", {
                    className: styles.link,
                    children: /*#__PURE__*/ _jsx(Link, {
                        href: `/jargon/${item.slug}`,
                        passHref: true,
                        legacyBehavior: true,
                        children: /*#__PURE__*/ _jsx(Secondary, {
                            element: "a",
                            "data-testid": "jargonLink",
                            className: styles.button,
                            children: "Read more"
                        })
                    })
                })
            }, index);
        })
    });
};
